import React, { useState } from 'react';
import Map from '../Misc/Map/Map';
import './VerSolarfarm.css';
import { Modal } from 'react-bootstrap';
import Leyenda from '../Misc/Map/Legend';
import StatusMapBox from '../Misc/Map/StatusMapBox';
import VerLateral from './Lateral/VerLateral';
import { Tab, Tabs } from 'react-bootstrap';
import Arbol from './Arbol/Arbol';

function VerSolarFarm() {
    const [abrirLeyenda, setAbriLeyenda] = useState(false);
    const [abrirDatosParque, setAbrirDatosParque] = useState(false);
    const [filtroDelMapa, setFiltroDelMapa] = useState('');
    var aemet = (JSON.parse(sessionStorage.getItem("configuration"))[0].aemetHTML);
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    const childToParent = (filtro) => {
        setFiltroDelMapa(filtro)
    }


    return (
        <div id="div-contenido" >
            <div id="div-map-solarfarm">
                <Map code={code} filter={filtroDelMapa}/>
            </div>
            <div id='div-mapa-status-box'>
                <StatusMapBox code={code} childToParent={childToParent}/>
            </div>
            <div id="div-boton-leyenda">
                <button id="boton-leyenda" onClick={() => setAbriLeyenda(true)}>Leyenda</button>
            </div>
            <div id="div-boton-datos-parque">
                <button id="boton-datos-parque" onClick={() => setAbrirDatosParque(true)}>Datos Parque</button>
            </div>
            <Modal size="lg" centered show={abrirLeyenda} onHide={() => setAbriLeyenda(false)} backdrop="static" aria-labelledby="Leyenda">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Leyenda
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Leyenda />
                </Modal.Body>
            </Modal>

            <Modal centered show={abrirDatosParque} onHide={() => setAbrirDatosParque(false)} backdrop="static" aria-labelledby="Datos Parque">
                <Modal.Header closeButton>
                    <Modal.Title>Datos Parque</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs defaultActiveKey="datos-parque">
                        <Tab eventKey="datos-parque" title="Datos Parque"><VerLateral /></Tab>
                        <Tab eventKey="arbol" title="Árbol"><Arbol /></Tab>
                    </Tabs>
                    <iframe name="iframe_aemet_id33044" width="100%" height="100%" tabIndex="0" id="iframe_aemet_id33044" src={aemet}/>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default VerSolarFarm